'use client';

export var TimeProp = /*#__PURE__*/function (TimeProp) {
  TimeProp["DisabledHours"] = "disabledHours";
  TimeProp["DisabledMinutes"] = "disabledMinutes";
  TimeProp["DisabledSeconds"] = "disabledSeconds";
  TimeProp["ShouldDisableHour"] = "shouldDisableHour";
  TimeProp["ShouldDisableMinute"] = "shouldDisableMinute";
  TimeProp["ShouldDisableSecond"] = "shouldDisableSecond";
  TimeProp["HideHours"] = "hideHours";
  TimeProp["HideMinutes"] = "hideMinutes";
  TimeProp["HideSeconds"] = "hideSeconds";
  return TimeProp;
}({});
export var calendarOnlyProps = [TimeProp.DisabledHours, TimeProp.DisabledMinutes, TimeProp.DisabledSeconds, TimeProp.HideHours, TimeProp.HideMinutes, TimeProp.HideSeconds];